import { api } from '../../utils/api';

export function start(oid: string, pid: string, runid: string) {
  return api
    .get<{ redirectToken: string }>(`/orgs/${oid}/${pid}/rshiny/start/${runid}`)
    .then(({ data }) => data);
}
